<!-- Project: GSSC Pilot Front-end -->
<!-- Filename: AssetFilter.vue -->
<!-- Copyright European Space Agency, 2020 -->
<!-- This file is part of the source code package for contract PO PO 5001024866 -->
<!-- No part of the package, including this file, may be copied, modified,      -->
<!-- propagated, or distributed without prior approval by ESA.                  -->
<template>
  <div class="assets__filter">
    <tree-view
      class="assets__filter-tree"
      :model="filters"
      :display="display"
      category="children"
      :openerOpts="openerOpts"
      :selection="value"
      :onSelect="onSelect"
      :strategies="strategies"
      :css="css"
      :transition="transition"
    ></tree-view>

    <!-- Modal for extra filters -->
    <div
      class="assets__filter-modal modal"
      id="assets__filter-modal"
      tabindex="-1"
      role="dialog"
      aria-labelledby="extraFilters"
      aria-hidden="true"
    >
      <div class="modal-dialog" role="document">
        <div v-if="activeExpander" class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="exampleModalLabel">{{ activeExpander.label }}</h5>
            <span v-if="allNonePossible">
              <button class="assets__filter-modal-all btn btn-primary btn-sm" @click="selectAll">
                All
              </button>
              |
              <button class="assets__filter-modal-none btn btn-primary btn-sm" @click="selectNone">
                None
              </button>
            </span>
            <span>
              <span role="button" @click="listOrder = !listOrder">Hits&nbsp;&nbsp;</span>
              <div class="custom-control custom-switch d-inline">
                <input
                  type="checkbox"
                  class="assets__filter-modal-az custom-control-input"
                  id="orderSwitch"
                  v-model="listOrder"
                />
                <label role="button" class="custom-control-label" for="orderSwitch">A-Z</label>
              </div>
            </span>
            <button
              type="button"
              class="assets__filter-modal-close-x close"
              data-dismiss="modal"
              aria-label="Close"
              @click="modalClosed"
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <ul class="assets__filter-modal-list">
              <li v-for="(filter, idx) in activeExpander.modalFilters" :key="idx">
                <a
                  href="#"
                  :class="{ 'font-weight-bold': modalSelection.indexOf(filter) !== -1 }"
                  @click.prevent="toggleModalFilter(filter)"
                  >{{ filter.display }}</a
                >
              </li>
            </ul>
            <!-- <button
              type="button"
              class="assets__filter-modal-close-btn btn btn-primary"
              data-dismiss="modal"
              @click="modalClosed"
            >Close</button>-->
          </div>
          <div class="modal-buttons">
            <button
              type="button"
              class="assets__filter-modal-apply-btn btn btn-primary float-right"
              @click="applyAndClose"
            >
              Apply
            </button>
          </div>
          <div class="modal-footer"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { TreeView } from '@bosket/vue'
import helpers from '@/lib/helpers'

const MAX_NUMBER_OF_FILTERS = 50

export default {
  name: 'AssetFilter',
  components: {
    TreeView,
  },
  props: {
    filters: Array,
    value: Array,
    numberOfSelectedFilters: Number,
  },
  computed: {
    strategies() {
      return {
        selection: ['multiple'],
        click: ['toggle-fold', this.toggleSelect],
        fold: ['opener-control'],
      }
    },
    openerOpts() {
      return {
        position: 'left',
      }
    },
    css() {
      return {
        opener: 'opener icon-dropdown',
      }
    },
    transition() {
      return {
        // attrs: {
        //   appear: true,
        // },
        props: {
          name: 'tree-trans',
        },
      }
    },
    allNonePossible() {
      return (
        this.activeExpander.label !== 'Station / Platform' &&
        this.activeExpander.label !== 'Observed Satellite' &&
        this.activeExpander.label !== 'Observation Code'
      )
    },
    // selection() {
    //   console.log('selection', this.value)
    //   let currentSelection = []
    //   this.value.forEach(selected => {
    //     let firstLevelFilter = null
    //     this.filters.forEach(section => {
    //       const foundFilter = section.children.find(filter => filter.tagLabel == selected.tagLabel)
    //       if (foundFilter) {
    //         firstLevelFilter = foundFilter
    //       }
    //     })
    //     // (item => item.children.find(element => element.tagLabel == filter.tagLabel))
    //     // const secondLevelFilters = this.filters.forEach(item => {
    //     //   const expander = item.children.find(element => element.isExpander)
    //     //   return expander ? expander.modalFilters.find(element => element.tagLabel == filter.tagLabel) : 'jaja'
    //     // })
    //     console.log('first', firstLevelFilter)
    //     // console.log('second', secondLevelFilters)
    //     if (firstLevelFilter) {
    //       currentSelection = [...currentSelection, firstLevelFilter]
    //     }
    //     console.log({ currentSelection })
    //   })

    //   return currentSelection
    // },
  },
  data() {
    return {
      listOrder: true,
      activeExpander: null,
      display: (item) => {
        if (item.isExpander) {
          return this.$createElement(
            'a',
            {
              attrs: {
                href: '#',
              },
              on: {
                click: (e) => {
                  // show this filter's extra items in modal
                  this.activeExpander = item
                  this.sortList(true)
                  $('#assets__filter-modal').modal()
                  $('#assets__filter-modal').on('hidden.bs.modal', () => {
                    this.modalSelection = this.modalSelection.concat(this.removedSelection)
                    this.modalSelection = helpers.excludeFromArr(this.modalSelection, this.newSelection)
                    this.newSelection = []
                    this.removedSelection = []
                    this.modalClosed()
                  })
                },
              },
            },
            'More'
          )
        } else {
          return <span class="label"> {item.display}</span>
        }
      },
      // Toggle select only for leaf nodes
      toggleSelect: function(item) {
        if (item.children.length === 0 && !item.isExpander) {
          // console.group('TOGGLE SELECT')
          console.log('this.inputs.get().ancestors', this.inputs.get().ancestors)
          console.log({ item })
          // console.groupEnd()
          this.inputs.get().onSelect(item, this.inputs.get().ancestors, this.inputs.get().model)
        }
      },
      modalSelection: [],
      newSelection: [],
      removedSelection: [],
    }
  },
  methods: {
    onSelect(newSelection) {
      console.log({ newSelection })
      console.log('NUMBER OF FILTERS new', newSelection.length)
      if (newSelection.length > MAX_NUMBER_OF_FILTERS) {
        this.$emit('showMaxNumberOfFiltersModal')
        return
      }
      this.$emit('input', newSelection)
      $('#assets__filter-modal').modal('hide')
    },
    toggleModalFilter(filter) {
      // console.group('TOGGLE IN MODAL')
      console.log('Modal - Current value was', this.value)
      const idx = this.modalSelection.indexOf(filter)
      const idxNewSelection = this.newSelection.indexOf(filter)
      const idxRemovedSelection = this.removedSelection.indexOf(filter)

      if (idx === -1) {
        // Not selected yet, add to selection
        this.modalSelection = this.modalSelection.concat([filter])
        //this.onSelect(this.value.concat([filter]))
        if (idxRemovedSelection === -1) {
          this.newSelection = this.newSelection.concat([filter])
        } else {
          this.removedSelection = this.removedSelection
            .slice(0, idxRemovedSelection)
            .concat(this.removedSelection.slice(idxRemovedSelection + 1))
        }
      } else {
        // Already selected, remove from selection
        this.modalSelection = this.modalSelection.slice(0, idx).concat(this.modalSelection.slice(idx + 1))
        // this.onSelect(this.value.slice(0, idx).concat(this.value.slice(idx + 1)))
        if (idxNewSelection === -1) {
          this.removedSelection = this.removedSelection.concat([filter])
        } else {
          this.newSelection = this.newSelection
            .slice(0, idxNewSelection)
            .concat(this.newSelection.slice(idxNewSelection + 1))
        }
      }
      console.log('number of filters selected', this.modalSelection.length)
    },
    applyAndClose() {
      console.log(this.modalSelection)
      this.onSelect(this.modalSelection)
      this.listOrder = true
    },
    modalClosed() {
      this.listOrder = true
    },
    selectAll() {
      let filtersToAdd = []
      for (let i = 0; i < this.activeExpander.modalFilters.length; i++) {
        const filter = this.activeExpander.modalFilters[i]
        const idx = this.modalSelection.indexOf(filter)
        if (idx === -1) {
          // Not selected yet, add to selection
          filtersToAdd.push(filter)
        }
      }
      this.modalSelection = this.modalSelection.concat(filtersToAdd)
      //this.onSelect(this.value.concat(filtersToAdd))
      //this.onSelect(this.value)
      // console.log(this.value)
      // console.log(this.filters)
    },
    selectNone() {
      let valueRemoving = this.modalSelection
      for (let i = 0; i < this.activeExpander.modalFilters.length; i++) {
        const filter = this.activeExpander.modalFilters[i]
        const idx = valueRemoving.indexOf(filter)
        if (idx !== -1) {
          //Selected item, needs to be unselected
          valueRemoving = valueRemoving.slice(0, idx).concat(valueRemoving.slice(idx + 1))
        }
      }
      this.modalSelection = valueRemoving
      // this.onSelect(valueRemoving)
    },
    sortList(alphabetical) {
      if (alphabetical) {
        this.activeExpander.modalFilters.sort((a, b) => (a.label > b.label ? 1 : b.label > a.label ? -1 : 0))
      } else {
        this.activeExpander.modalFilters.sort((a, b) => {
          if (a.count > b.count) {
            return -1
          }
          return 1
        })
      }
    },
  },
  watch: {
    listOrder: function(alphabetical) {
      this.sortList(alphabetical)
    },
    value: function() {
      console.log('this.value', this.value)
      console.log('this.filters', this.filters)
      this.modalSelection = this.value
    },
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '~@/styles/globals';

////////////////////////
// Scrollable filters //
.assets__filter {
  overflow-y: auto;
  max-height: 129vh;

  &::-webkit-scrollbar {
    border-radius: 4px;
    background-color: #f0f0ef;
    -webkit-appearance: none;
    width: 7px;
    height: 7px;
  }

  // Overwrite default safari behavior to show scrollbars always
  &::-webkit-scrollbar-thumb {
    border-radius: 4px;
    background-color: rgba(0, 0, 0, 0.5);
    box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
    -webkit-box-shadow: 0 0 1px rgba(255, 255, 255, 0.5);
  }
}
////////////////////////

.assets__filter-tree {
  /* Elements */
  ul {
    list-style-type: none;
    padding-left: 2em;

    &.depth-0 {
      padding: 0;
    }
  }

  ul:not(.depth-0) > li {
    .item {
      transition: all 0.3s;
      border-left: 4px solid $black-45;
    }

    .label {
      color: $black-45;
    }
  }

  ul > li > span.item {
    display: block;
    padding: 0.5em;

    &:hover {
      cursor: pointer;
      background-color: $light;
    }

    span {
      vertical-align: middle;
    }
  }

  /* Root list */
  ul.depth-0 {
  }

  /* Not disabled */
  ul li:not(.disabled) {
  }

  ul li:not(.disabled) > span.item {
  }

  /* Selected */
  ul li.selected {
    .item {
      border-left: 4px solid $pure-teal;
    }

    .label {
      color: $primary;
    }
  }

  ul li.selected > span.item {
  }

  /* Categories : Nodes with children */
  ul li.category {
    // position: relative;

    // &::after {
    //   display: none;
    //   position: absolute;
    //   width: 100px;
    //   height: 20px;
    //   top: 0px;
    //   left: 40px;
    //   content: 'Click to expand';
    // }

    // &:hover:after {
    //   display: block;
    // }
  }

  ul li.category > span.item > .opener::before {
    display: inline-block;
    transition: all 0.3s;
    color: $pure-teal;
  }

  /* Folded */
  ul li.category.folded {
  }

  ul li.category.folded > span.item {
  }

  ul li.category.folded > span.item > .opener::before {
    transform: rotate(-90deg);
  }

  /* Unfolded */
  ul li.category:not(.folded) {
  }

  ul li.category:not(.folded) > span.item {
  }

  ul li.category:not(.folded) > span.item > .opener::before {
  }

  /* Opener */
  ul li.category > span.item > .opener {
    color: $secondary;
  }

  ul li.category > span.item > .opener::after {
  }

  /* Folded async */
  li.category.async {
  }

  li.category.async > span.item {
  }

  /* Loading async */
  li.category.loading {
  }

  li.category.loading > span.item {
  }

  /* Animations on component creation / destruction */
  .tree-trans-enter,
  .tree-trans-leave-to {
    max-height: 0px;
    transform: scaleY(0);
    transform-origin: top;
  }

  .tree-trans-enter-to,
  .tree-trans-leave {
    max-height: 500px;
  }

  .tree-trans-enter-active {
    transition: all 0.3s ease-in;
  }

  .tree-trans-leave-active {
    transition: all 0.3s ease-out;
  }

  /* Drag'n'drop */
  ul.dragover {
  }

  li.dragover {
  }

  li.dragover > span.item {
  }

  li.nodrop {
  }

  li.nodrop > span.item {
  }
}

.assets__filter-modal {
  .modal-header {
    .close {
      margin-left: 0;
    }
  }

  .modal-buttons {
    padding: 20px;
  }

  .modal-body {
    max-height: 56vh;
    overflow-y: auto;
  }
}

.assets__filter-modal-list {
  padding: 0;
  list-style-type: none;
}

.assets__filter-modal {
  #exampleModalLabel {
    // max-width: 105px;
  }

  .assets__filter-modal-all,
  .assets__filter-modal-none {
    padding: 2px 5px;
  }
}
</style>
